import { useQuery } from '@tanstack/react-query';

import { getCustomer, getCustomers, getMe } from '@/react-query/services/customer';

import { Card, CardType, DebitAccount, Organisation, User } from '@generated-types';

export const useCustomer = (card: Card | undefined) =>
    useQuery<User | Organisation>({
        queryKey: ['customer', card],
        queryFn: () => getCustomer(card!.type, card!.owner),
        enabled: card !== undefined,
    });

export const useCurrentCustomer = () =>
    useQuery<User>({
        queryKey: ['me'],
        queryFn: getMe,
    });

export const useMultipleCustomersFromAccounts = (type: CardType, accounts: DebitAccount[]) => {
    const customerNumbers = accounts.map((account) => account.owner).sort();

    return useQuery({
        queryKey: ['MultipleCustomersFromAccounts', customerNumbers, type],
        queryFn: () => getCustomers(type, customerNumbers),
        enabled: accounts.length > 0,
    });
};

export const useCustomerFromAccount = (account: DebitAccount | undefined | null, refresh = false) =>
    useQuery<User>({
        queryKey: ['customerFromAccount', account, refresh],
        queryFn: () => getCustomer(CardType.DEBIT, account!.owner, refresh),
        enabled: !!account,
        retry: 0,
    });
